import InputForm from "./InputForm";
import styles from "./newsletterWidgetTop.module.scss";

const NewsletterWidgetTop = () => (
  <div className={styles.container}>
    <p className={styles.widgetText}>Subscribe to our newsletter</p>
    <div className={styles.subscribeAndShare}>
      <InputForm location="top" />
    </div>
  </div>
);
export default NewsletterWidgetTop;
